<div id="rtc-detection">
    <div id="rtc-detection-overlay" [ngClass]="{'no-display' : !aboveModalOverlayIsOpen }">
        <div class="text-wrapper">
            <i class="far fa-arrow-up"></i>
            {{'RTC_DETECTION.CAMERA_ACCESS.KLICK_ALLOW_MSG' | translate }}
        </div>
    </div>
    <ng-template appRtcDetectionStep></ng-template>
</div>
